import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { UserQueryKeys } from './userQueryKeys';

export type SetUserPinVariables = {
    id: string;
    pin: string;
};

/**
 * Sets/resets a user's 4-digit PIN. On success the user's `hasPin` flips true,
 * so we invalidate the list to refresh the indicator.
 */
export const useSetUserPinMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, SetUserPinVariables>({
        mutationFn: ({ id, pin }) => apiClient.users.setUserPin(id, { pin }),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({ queryKey: UserQueryKeys.all });
            }
        },
    });
};
